module.exports = __webpack_public_path__ + "static/media/LancamentosFinanceiros2.48d8d007.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancLancamentosFinanceiros/LancamentosFinanceiros2.png
// module id = 2151
// module chunks = 0